<template>
  <FormContainer v-if="metaModuleEnCours?.avecSubrogation?.$status !== PropertyStatus.NotPresent">
    <template #title>Modalité de paiement</template>
    <template #content>
      <div class="form__bloc">
        <WrapperToggleSwitch
          id="field_53"
          v-model="avecSubrogationModel"
          label="Paiement direct par l'OPCO à l'organisme de formation"
          :items="OuiOuNon"
          :required="metaModuleEnCours?.avecSubrogation?.$status === PropertyStatus.Required"
          :alertLabel="metaModuleEnCours?.avecSubrogation?.$messageErreurDirty!"
          :readonly
          help="cf. conditions générales AKTO : La délégation de paiement, auprès du prestataire, n’est pas acquise de plein droit. AKTO se réserve, discrétionnairement, le droit d’accepter ou non la délégation de paiement."
          class="col-10 col-md-14 col-sm-36"
        />
      </div>
    </template>
  </FormContainer>

  <FraisFormation
    :frais-data-par-mode
    :readonly
    :nature-frais="store.lov.NatureFrais"
    :modifie-frais
    :msg-information
    :msg-erreur="metaModuleEnCours?.fraisPedagogiques?.$messageErreurDirty!"
  />
</template>

<script setup lang="ts">
  import { PropertyStatus } from '@/features/domaine/property-status/PropertyStatus'
import { useDemandeAFStore } from '@/features/interface/demande/af/useDemandeAFStore'
import { FormContainer, FraisFormation } from '@/features/interface/demande/shared'
import { OuiOuNon } from '@/features/interface/shared/tools'
import { storeToRefs } from 'pinia'
import { computed, inject } from 'vue'
import { AF_MODULES_ACTIONS } from '../../useModuleActions'

  const store = useDemandeAFStore()
  const { setupFieldWithOptions } = store
  const { moduleEnCours, activeModuleIndex, modifieFrais, readonly, fraisDataParMode, metaModuleEnCours } =
    inject(AF_MODULES_ACTIONS)!
  const { model } = storeToRefs(store)

  const avecSubrogationModel = setupFieldWithOptions({
    getValue: () => moduleEnCours.value?.avecSubrogation,
    setPatch(patch, value) {
      const modulePatch = patch.formation!.modules!.at(activeModuleIndex.value!)!
      modulePatch.avecSubrogation = value
    },
  })

  const msgInformation = computed(() => {
    if (['ActionStandard', 'PDC', 'AfFpe'].includes(model.value!.sousDispositif!)) {
      return `Si vous ne souhaitez pas de remboursement pour les frais pédagogiques, veuillez saisir 0. Cependant, vous devez demander le remboursement d'au moins un autre frais (autres frais pédagogiques, frais annexes ou rémunération).`
    }
    if (model.value!.sousDispositif === 'Fse') {
      return `Seuls les coûts pédagogiques de face à face avec un formateur sont finançables par le FSE. Ne sont finançables par le FSE, ni les frais annexes, ni les coûts de positionnement/évaluation, ni les frais de jury ou certification, ni les coûts d'ingénierie, prestation ou audit.`
    }
    if (model.value!.sousDispositif === 'FTJ') {
      return `Seuls les coûts pédagogiques de face à face avec un formateur sont finançables par le FTJ. Ne sont finançables par le FTJ, ni les frais annexes, ni les coûts de positionnement/évaluation, ni les frais de jury ou certification, ni les coûts d'ingénierie, prestation ou audit.`
    }
    return null
  })
</script>
